export default __webpack_public_path__ + "static/media/arrow-up.d594e252.svg";